// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Yb9k3","blackNextButton":"styles_blackNextButton__3lEz4","ant-btn-primary":"styles_ant-btn-primary__15gDE"};